import React, { useState } from "react";
import "./profilenew.scss";
import { Link } from "react-router-dom";
import { Button } from "react-bootstrap";

const dates = [
  { day: "Fri", date: "31" },
  { day: "Sat", date: "01" },
  { day: "Sun", date: "02" },
  { day: "Mon", date: "03" },
  { day: "Tue", date: "04" },
  { day: "Fri", date: "31" },
  { day: "Sat", date: "01" },
  { day: "Sun", date: "02" },
  { day: "Mon", date: "03" },
  { day: "Tue", date: "04" }
];

const slots = [
  "9.00-10:00","10:00-10:30","10:30-11:00","11:00-11:30","11:30-12:00",
  "12:00-12:30","12:30-01:00","01:00-01:30","01:30-02:00","02:00-02:30",
  "02:30-03:00","03:00-03:30","03:30-04:00","04:00-04:30","04:30-05:00"
];

export default function Profilenew() {
  const [activeDate, setActiveDate] = useState(2);
  const [selectedSlot, setSelectedSlot] = useState(0);

  return (
    <div className="container py-4">
      <div className="d-flex gap-3 justify-content-between"><div>
  <h4 className='mt-3 font-bold mb-4'><Link to="/homepage"><svg width="35" height="35" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="43" height="43" rx="4.5" stroke="#161616" stroke-opacity="0.3" />
            <path d="M25.8865 31.6615L16.165 21.9999L25.8865 12.3384L27.1748 13.6267L18.8016 21.9999L27.1748 30.3732L25.8865 31.6615Z" fill="#161616" />
          </svg></Link>&nbsp;
          Profile</h4></div>
          <div> 
            <button className="btn bg-light border d-inline-flex align-items-center gap-2 px-2 py-2 rounded-2 fw-semibold text-dark">
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M4.16663 15.8327H5.21788L13.7483 7.30226L12.697 6.25102L4.16663 14.7814V15.8327ZM2.91663 17.0827V14.2623L13.9087 3.27497C14.0347 3.16053 14.1738 3.07213 14.326 3.00977C14.4784 2.94727 14.6381 2.91602 14.8052 2.91602C14.9723 2.91602 15.1341 2.94567 15.2906 3.00497C15.4473 3.06428 15.5859 3.15858 15.7066 3.28789L16.7243 4.31831C16.8536 4.439 16.9458 4.57789 17.0008 4.73497C17.0558 4.89206 17.0833 5.04914 17.0833 5.20622C17.0833 5.37386 17.0547 5.53379 16.9975 5.68602C16.9402 5.83838 16.8492 5.97754 16.7243 6.10352L5.73704 17.0827H2.91663ZM13.2135 6.78581L12.697 6.25102L13.7483 7.30226L13.2135 6.78581Z" fill="#222222"/>
</svg>

  Edit
</button>
</div>
          </div>
      {/* timezone alert */}
    
   <div className="row g-4">

        {/* LEFT COLUMN */}
        <div className="col-lg-5">

          {/* Profile Card */}
          <div className="card border-0 shadow-sm mb-3">
            <div className="card-body d-flex justify-content-between align-items-center">

              <div className="d-flex align-items-center">
                <div
                  className="rounded-circle bg-secondary bg-opacity-25 d-flex align-items-center justify-content-center me-3"
                  style={{ width: 60, height: 60 }}
                >
                  📤
                </div>

                <div>
                  <h5 className="fw-bold mb-1">Karan Singh</h5>
                  <div className="text-muted small">karansingh123@gmail.com</div>
                  <div className="text-muted small">9828376378</div>
                </div>
              </div>

              <div className="d-flex align-items-center">
                <img src="https://i.pravatar.cc/40" alt="" className="rounded-circle border" />
                <div
                  className="rounded-circle bg-secondary text-white d-flex align-items-center justify-content-center ms-1"
                  style={{ width: 32, height: 32, fontSize: 12 }}
                >
                  A
                </div>
              </div>

            </div>
          </div>


          {/* Session Timings */}
          <div className="card border-0 shadow-sm mb-3">
            <div className="card-body d-flex justify-content-between align-items-center">
              <span className="fw-semibold">Session Timings</span>
              <span>›</span>
            </div>
          </div>


          {/* About */}
          <div className="card border-0 shadow-sm mb-3">
            <div className="card-body">
              <div className="fw-semibold text-muted mb-2">About Me</div>
              <p className="small text-secondary mb-0">
                Lorem Ipsum is simply dummy text of the printing and typesetting industry.
                Lorem Ipsum has been the industry's standard dummy text ever since the
                1500s, when an unknown printer took a galley of type and scrambled it
                to make a type specimen book.
              </p>
            </div>
          </div>


          {/* Toggle */}
          <div className="card border-0 shadow-sm mb-3">
            <div className="card-body d-flex justify-content-between align-items-center">
              <span className="fw-semibold">Auto Accept Requests</span>
              <div className="form-check form-switch m-0">
                <input className="form-check-input" type="checkbox" />
              </div>
            </div>
          </div>


          {/* Menu List */}
          <div className="card border-0 shadow-sm">
            <div className="list-group list-group-flush">

              <a
                href="https://theprimeshark.com/privacy-policy/"
                target="_blank"
                rel="noopener noreferrer"
                className="list-group-item d-flex justify-content-between text-decoration-none text-dark"
              >
                <span>📄 Privacy Policy</span>
                <span>›</span>
              </a>

              <div className="list-group-item d-flex justify-content-between">
                <span>📄 About Us</span>
                <span>›</span>
              </div>

              <a
                href="https://theprimeshark.com/terms-of-use/"
                target="_blank"
                rel="noopener noreferrer"
                className="list-group-item d-flex justify-content-between text-decoration-none text-dark"
              >
                <span>📄 Terms & Conditions</span>
                <span>›</span>
              </a>

              <div className="list-group-item d-flex justify-content-between">
                <span>↪ Logout</span>
                <span>›</span>
              </div>

            </div>
          </div>

        </div>



        {/* RIGHT COLUMN */}
        <div className="col-lg-7">

          <div className="card border-0 shadow-sm">
            <div className="card-body">

              <div className="d-flex justify-content-between border-bottom py-3">
                <span className="text-muted">Address</span>
                <span className="fw-medium text-end">
                  6th Floor, Olympia Mumbai Bangalore Highway Baner-411045
                </span>
              </div>

              <div className="d-flex justify-content-between border-bottom py-3">
                <span className="text-muted">Social Profiles</span>
                <span className="fw-medium text-end text-success">
                  x.karansingh3828 <br />
                  linkedin.karansingh
                </span>
              </div>

              <div className="d-flex justify-content-between border-bottom py-3">
                <span className="text-muted">Portfolio</span>
                <span className="fw-medium text-success">www.karansingh.com</span>
              </div>

              <div className="d-flex justify-content-between border-bottom py-3">
                <span className="text-muted">Education</span>
                <span className="fw-medium">MBA Finance</span>
              </div>

              <div className="d-flex justify-content-between border-bottom py-3">
                <span className="text-muted">Professional Experience</span>
                <span className="fw-medium">12 Years</span>
              </div>


              {/* Industry */}
              <div className="border-bottom py-3">
                <div className="text-muted mb-2">Industry Experience</div>
                <span className="badge rounded-pill bg-light text-dark border me-2">Human Resource</span>
                <span className="badge rounded-pill bg-light text-dark border me-2">Hospitality</span>
                <span className="badge rounded-pill bg-light text-dark border">IT</span>
              </div>


              {/* Geography */}
              <div className="border-bottom py-3">
                <div className="text-muted mb-2">Geographics</div>
                <span className="badge rounded-pill bg-light text-dark border me-2">Asia</span>
                <span className="badge rounded-pill bg-light text-dark border me-2">Europe</span>
                <span className="badge rounded-pill bg-light text-dark border">USA</span>
              </div>


              {/* Market */}
              <div className="border-bottom py-3">
                <div className="text-muted mb-2">Market Focus</div>
                <span className="badge rounded-pill bg-light text-dark border me-2">Asia</span>
                <span className="badge rounded-pill bg-light text-dark border me-2">Europe</span>
                <span className="badge rounded-pill bg-light text-dark border">USA</span>
              </div>


              <div className="d-flex justify-content-between border-bottom py-3">
                <span className="text-muted">Availability Type</span>
                <span className="fw-medium">Virtual</span>
              </div>

              <div className="d-flex justify-content-between pt-3">
                <span className="text-muted">Charges</span>
                <span className="fw-medium">Hourly based</span>
              </div>

            </div>
          </div>

        </div>

      </div>

    </div>
  );
}
